import React from 'react';
import { number, func } from 'prop-types';
import Pagination from 'components/pagination';

export default class ItemPagination extends React.Component {
    constructor(props) {
        super(props);
        this.clickPage = this.clickPage.bind(this);
    }
    shouldComponentUpdate(newProps) {
        return (
            this.props.totalPages !== newProps.totalPages ||
            this.props.currentPage !== newProps.currentPage
        );
    }
    clickPage(value) {
        this.props.changePage(value.selected);
    }

    render() {
        if (this.props.totalPages <= 1) {
            return null;
        }

        return (
            <div className="listing-pagination-section">
                <div className="listing-pagination">
                    <Pagination
                        pageNum={this.props.totalPages}
                        pageRangeDisplayed={5}
                        marginPagesDisplayed={1}
                        clickCallback={this.clickPage}
                        forceSelected={this.props.currentPage}
                        initialSelected={this.props.currentPage}
                        previousLabel="Previous"
                        prevIcon="arrow-drop-left"
                        nextLabel="Next"
                        nextIcon="arrow-drop-right"
                        containerClassName="c-r-pagination"
                        activeClassName="c-r-pagination__item--active"
                        pageClassName="page"
                        mobileBreakpoint={764}
                    />
                </div>
            </div>
        );
    }
}

ItemPagination.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    totalPages: number.isRequired,
    currentPage: number.isRequired,
    changePage: func.isRequired
    /* eslint-enable react/no-typos */
};
